module.exports = __webpack_public_path__ + "static/media/BugTrackerPic.688d386c.png";